import lowerCase from 'lodash/lowerCase';
export const _lowerCase = lowerCase;
